import React from "react";
import PageLayout from "../components/PageLayout";
import Spacer from "../components/Spacer";

const TEXTBOOKS = [
  {
    title: "Operating Systems: Three Easy Pieces",
    authors: "Remzi H. Arpaci-Dusseau and Andrea C. Arpaci-Dusseau",
    link: "https://pages.cs.wisc.edu/~remzi/OSTEP/",
  },
  {
    title: "Computer Systems: A Programmer's Perspective",
    authors: "Randal E. Bryant and David R. O'Hallaron",
    link: "https://csapp.cs.cmu.edu/",
  },
  {
    title: "Advanced Programming in the UNIX Environment",
    authors: "W. Richard Stevens and Stephen A. Rago",
    link: "http://www.apuebook.com/",
  },
  {
    title: "Algorithms Illuminated",
    authors: "Tim Roughgarden",
    link: "https://www.algorithmsilluminated.org/",
  },
  {
    title: "Database System Concepts",
    authors: "Abraham Silberschatz, Henry F. Korth, and S. Sudarshan",
    link: "https://www.db-book.com/",
  },
];

const Reading = () => (
  <PageLayout>
    <div className="text-[1.18rem] lg:text-[1.05rem] xl:text-[1.18rem] font-lusitana">
      <h1 className="text-[2.8rem] mb-[0.2rem] sm:mb-[0rem] sm:text-[3.62rem] xl:text-[4rem] font-bold font-garamond">
        Reading
      </h1>
      <p>Select reading I enjoy.</p>

      <Spacer height="1rem" />

      <h1 className="text-[2.2rem] font-bold font-garamond">Textbooks</h1>
      <Spacer height="0.3rem" />
      <ul className="list-disc pl-6 space-y-1 text-[1.05rem] lg:text-[0.95rem] xl:text-[1.05rem]">
        {TEXTBOOKS.map(({ title, authors, link }) => (
          <li key={title}>
            <a href={link} target="_blank" rel="noopener noreferrer" className="italic text-blue-800 underline">
              {title}
            </a>
            , {authors}
          </li>
        ))}
      </ul>

      <Spacer height="1.6rem" />
    </div>
  </PageLayout>
);

export default Reading;
